import React from "react"
import { view } from "react-easy-state"
import { withRouter } from "react-router"
import { isMobile } from "react-device-detect"
import { message } from "antd"

import Footer from "components/common/layouts/Footer"
import ContentLoader from "components/common/ContentLoader"
import QuestionnaireDetails from "components/pages/students/questionnaires/show/QuestionnaireDetails"
import QuestionnaireListSider from "components/pages/students/questionnaires/show/QuestionnaireListSider"
import AskDoubt from "components/pages/students/AskDoubt"

import globalStore from "store"

import QuestionnairesService from "services/students/questionnaires.service"

class QuestionnairesShowPage extends React.Component {
  async componentDidMount() {
    const { questionnaireId, chapterId } = this.props.match.params

    const pageState = globalStore.ui.students.questionnaires.show
    await QuestionnairesService.show({ pageState, questionnaireId, chapterId })
    console.log(JSON.parse(JSON.stringify(pageState)))
  }

  goBack = () => {
    const { chapterId } = this.props.match.params

    this.props.history.push(`/chapters/${chapterId}`)
  }

  renderQuestionnaireContent() {
    const pageState = globalStore.ui.students.questionnaires.show
    const {
      chapterErrors,
      questionnaireErrors,
      questionnaireAttemptErrors,
      allQuestionnairesErrors,
      API_QUESTIONNAIRES_SHOW_STATUS,
    } = pageState

    if (!API_QUESTIONNAIRES_SHOW_STATUS) return <ContentLoader />
    if (API_QUESTIONNAIRES_SHOW_STATUS === "pending") return <ContentLoader />
    if (API_QUESTIONNAIRES_SHOW_STATUS === "rejected") return <ContentLoader />

    if (chapterErrors) {
      message.destroy()
      message.error(chapterErrors)
      this.props.history.push("/courses")
      return
    }

    if (questionnaireErrors || questionnaireAttemptErrors) {
      const { chapterId } = this.props.match.params
      message.destroy()
      message.error(questionnaireErrors || questionnaireAttemptErrors)
      this.props.history.push(`/chapters/${chapterId}`)
      return
    }

    if (allQuestionnairesErrors) {
      const { chapterId } = this.props.match.params
      message.destroy()
      message.error(allQuestionnairesErrors)
      // this.props.history.push(`/chapters/${chapterId}/questionnaires/${questionnaireId}`)
      this.props.history.push(`/chapters/${chapterId}`)
      return
    }

    return (
      <React.Fragment>
        <QuestionnaireListSider goBack={this.goBack} />
        <QuestionnaireDetails />
      </React.Fragment>
    )
  }

  componentWillUnmount() {
    globalStore.ui.students.questionnaires.show = {}
  }

  render() {
    return (
      <div className={`page lecture-page ${isMobile ? "mobile" : ""}`}>
        {this.renderQuestionnaireContent()}
        <Footer />
        <AskDoubt />
      </div>
    )
  }
}

export default withRouter(view(QuestionnairesShowPage))
